import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import ClanLeaderboard from "@/views/ClanLeaderboard";

Vue.use(VueRouter)

const routes = [
    {
        path: '/clans',
        name: 'ClanLeaderboard',
        component: ClanLeaderboard
    },
    {
        path: '/',
        name: 'Home',
        component: Home
    },
]

const router = new VueRouter({
    routes
})

export default router
